"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "zh": {
        "translation": {
            "left_navigation": {
                "loading": "正在加载",
                "hidden_target": "由于您应用的过滤器，无法显示您的选择。若要显示项目，请移除相应的过滤器。",
                "sidenav_open": "打开导航",
                "sidenav_close": "关闭导航",
                "expand": "展开",
                "collapse": "折叠",
                "small_search": "请输入至少 2 个字符进行搜索。",
                "no_search_results": "未找到结果。",
                "filter_search": "筛选…",
                "collection_archive": "集合存档",
                "activities": {
                    "title": "活动",
                    "details": "详情",
                    "reset": "重置",
                    "load_more": "加载更多",
                    "no_results": "指定的筛选器没有活动。",
                    "no_more_results": "已到达指定筛选器的最后活动。",
                    "actions": {
                        "created": "创建时间",
                        "deleted": "删除",
                        "updated": "已更新"
                    }
                },
                "settings": {
                    "title": "设置"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=zh.js.map